import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1",
  ref: "surveyConfirmModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-warning" }
const _hoisted_5 = { class: "modal-title text" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.translate("REPORT_ALERT_MESSAGE")), 1),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("span", { class: "svg-icon svg-icon-2x" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (warning, index) => {
            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(warning[_ctx.translateKey("warning")]), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _toDisplayString(_ctx.translate("CONFIRM_MODAL_BUTTON_MESSAGE_CLOSE")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-dark-blue",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
          }, _toDisplayString(_ctx.translate("CONFIRM_MODAL_BUTTON_MESSAGE_CONTINUE")), 1)
        ])
      ])
    ])
  ], 512))
}